<template>
  <div class="question-container my-5 p-4 border rounded shadow-sm bg-light">
    <div class="form-group">
      <!-- Text input -->
      <TextInput
        v-if="question.type === 'textbox'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Number input -->
      <NumberInput
        v-if="question.type === 'number'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Date input -->
      <DateInput
        v-if="question.type === 'date'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Dropdown input -->
      <DropdownInput
        v-if="question.type === 'dropdown'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Dropdown Search input -->
      <DropdownInputSearch
        v-if="question.type === 'dropdown-search'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

       <!-- Dropdown Search input -->
      <DropdownInputSearchWithOthers
        v-if="question.type === 'dropdown-search-with-others'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

       <!-- Dropdown Search input -->
      <DropdownInputSearchWithOthersOut
        v-if="question.type === 'dropdown-search-with-others-out'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      

      <!-- Field group input -->
      <FieldGroup
        v-if="question.type === 'field'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Radio input -->
      <RadioInput
        v-if="question.type === 'radio'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Radio-list input -->
      <RadioListInput
        v-if="question.type === 'radio-list'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Checkbox input -->
      <CheckboxInput
        v-if="question.type === 'checkbox'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Slider table input -->
      <SliderTableInput
        v-if="question.type === 'table-slider'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Gender switch input -->
      <GenderSwitch
        v-if="question.type === 'radio_gender'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Rating input -->
      <RatingInput
        v-if="question.type === 'rating'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Field-list input -->
      <FieldListInput
        v-if="question.type === 'field-list'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <!-- Field-list input -->
      <MonthYearInput
        v-if="question.type === 'month-year'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <YesOrNoWithInputInput
        v-if="question.type === 'yes-or-no-specify'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <DayMonthNumberInput
        v-if="question.type === 'number-days-month'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <MinuteHourNumberInput
        v-if="question.type === 'number-minutes-hour'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

       <MoneyInput
        v-if="question.type === 'money-input'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
      />

      <MultiDayMonthNumberInput
        v-if="question.type === 'multi-day-month-number'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
        @validation-status="forwardValidation"
      />

      <Q10Component
        v-if="question.type === 'q10-component'"
        :question="question"
        :required="question.required"
        :showValidation="showValidation"
        @validation-status="forwardValidation"
      />

       <Q13EComponent
          v-if="question.type === 'q13e-component'"
          :question="question"
          :required="question.required"
          :showValidation="showValidation"
          @validation-status="forwardValidation"
        />

      
     

      <div v-if="question.type === 'question-header'" class="question-header">
        <!-- <h3> <span v-if="question.number">{{ question.number }} .</span>  {{ question.question }}</h3> -->
        <question-display :question="question" customClass="header-1"></question-display>
      </div>

    </div>
  </div>
</template>

<script>
import CheckboxInput from './components/CheckboxInput.vue';
import DateInput from './components/DateInput.vue';
import DayMonthNumberInput from './components/DayMonthNumberInput.vue';
import DropdownInput from './components/DropdownInput.vue';
import DropdownInputSearch from './components/DropdownInputSearch.vue';
import DropdownInputSearchWithOthers from './components/DropdownInputSearchWithOthers.vue';
import DropdownInputSearchWithOthersOut from './components/DropdownInputSearchWithOthersOut.vue';
import FieldGroup from './components/FieldGroup.vue';
import FieldListInput from './components/FieldListInput.vue';
import GenderSwitch from './components/GenderSwitch.vue';
import MinuteHourNumberInput from './components/MinuteHourNumberInput.vue';
import MoneyInput from './components/MoneyInput.vue';
import MonthYearInput from './components/MonthYearInput.vue';
import MultiDayMonthNumberInput from './components/MultiDayMonthNumberInput.vue';
import NumberInput from './components/NumberInput.vue';
import Q10Component from './components/PlainQuestions/Q10Component.vue';
import Q13EComponent from './components/PlainQuestions/Q13EComponent.vue';
import RadioInput from './components/RadioInput.vue';
import RadioListInput from './components/RadioListInput.vue';
import RatingInput from './components/RatingInput.vue';
import SliderTableInput from './components/SliderTableInput.vue';
import TextInput from './components/TextInput.vue';
import YesOrNoWithInputInput from './components/YesOrNoWithInputInput.vue';
import QuestionDisplay from './utils/QuestionDisplay.vue';
export default {
  props: {
    question: Object,
    showValidation: Boolean
  },
  components: {
    TextInput,
    NumberInput,
    DropdownInput,
    DropdownInputSearch,
    DateInput,
    RadioInput,
    RadioListInput,
    CheckboxInput,
    SliderTableInput,
    GenderSwitch,
    RatingInput,
    FieldGroup,
    FieldListInput,
    MonthYearInput,
    YesOrNoWithInputInput,
    QuestionDisplay,
    DayMonthNumberInput,
    MinuteHourNumberInput,
    MoneyInput,
    DropdownInputSearchWithOthers,
    DropdownInputSearchWithOthersOut,
    MultiDayMonthNumberInput,
    Q10Component,
    Q13EComponent
  },
  methods: {
    forwardValidation(isValid) {
      this.$emit('validation-status', isValid); // bubble up to SurveyStage
    }
  }

};
</script>
